<div class="menu border-b border-light-700 dark:border-dark-300">
  <div class="menu__left"></div>
  <div class="menu__right">
    <div class="flex gap-1.5 px-4 py-2">
      <div [class]="itemStyles">
        <lib-tess-icon size="var(--font-size-xxl)" icon="menu:my-tasks" class="menu-icon" />
        <div class="mt-1">Tasks</div>
      </div>
      <div [class]="itemStyles">
        <lib-tess-icon size="var(--font-size-xxl)" icon="menu:events" class="menu-icon" />
        <div class="mt-1">Events</div>
      </div>
      <div [class]="itemStyles">
        <lib-tess-icon size="var(--font-size-xxl)" icon="menu:payments-due" class="menu-icon" />
        <div class="mt-1">Payments due</div>
      </div>
    </div>
  </div>
</div>
